module.exports = __webpack_public_path__ + "img/prepaid-tagged.b5c77018.png";